import { render } from "./UserData.vue?vue&type=template&id=12197cea&scoped=true"
import script from "./UserData.vue?vue&type=script&lang=ts"
export * from "./UserData.vue?vue&type=script&lang=ts"

import "./UserData.vue?vue&type=style&index=0&id=12197cea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12197cea"

export default script